import React, { useCallback } from 'react';
import { rem, Spacer } from 'design-system';
import InfoCard from 'design-system/InfoCard';
import Text from 'design-system/Text';
import { StyleSheet, View } from 'react-native';
import Amount from 'design-system/Amount';
import useColors from 'hooks/useColors';
import useShouldShowUpgrade from 'features/premium/hooks/useShouldShowUpgrade';
const BudgetingMonthlyCategoryToolTip = ({ baseLimit, rollingAccumulatedLimit, currency, totalLimit, totalSpending, isTotalBudget, onCard = true, extraPadding = true, extraPaddingBottom = false, }) => {
    const colors = useColors();
    const { isUnlockedForSpace } = useShouldShowUpgrade({
        benefitId: 'rollingBudgets',
    });
    const descriptionZeroBudget = useCallback(() => typeof baseLimit === 'number' &&
        typeof rollingAccumulatedLimit === 'number' && (<View style={styles.margin}>
            <Text TextThin-14 Secondary>
              {`${isTotalBudget
            ? `You don’t have a budget`
            : `This category doesn’t have a budget`} because you rolled over `}
              <Amount NumbersThin-14 Secondary value={{ value: rollingAccumulatedLimit, currency }}/>
              {` from the previous period. With a `}
              <Amount NumbersThin-14 Secondary value={{ value: baseLimit, currency }}/>
              {` budget, that brings your total to `}
              <Amount NumbersThin-14 Secondary value={{ value: 0, currency }}/>
              {` The remaining `}
              <Amount NumbersThin-14 Secondary value={{
            value: (rollingAccumulatedLimit || 0) + (baseLimit || 0),
            currency,
        }}/>
              {totalSpending !== 0 ? ` plus current spending ` : ` `}
              {`will carry over to the next period.`}
            </Text>
          </View>), [
        baseLimit,
        currency,
        isTotalBudget,
        rollingAccumulatedLimit,
        totalSpending,
    ]);
    const descriptionZeroBudgetNoExtraRollover = useCallback(() => typeof baseLimit === 'number' &&
        typeof rollingAccumulatedLimit === 'number' && (<View style={styles.margin}>
            <Text TextThin-14 Secondary>
              {`${isTotalBudget
            ? `You don’t have a budget`
            : `This category doesn’t have a budget`} budget because you rolled over `}
              <Amount NumbersThin-14 Secondary value={{ value: rollingAccumulatedLimit, currency }}/>

              {` from the previous period. With a `}

              <Amount NumbersThin-14 Secondary value={{ value: baseLimit, currency }}/>

              {` budget, that brings your total to `}

              <Amount NumbersThin-14 Secondary value={{ value: 0, currency }}/>

              {`.`}
            </Text>
          </View>), [baseLimit, currency, isTotalBudget, rollingAccumulatedLimit]);
    if (totalLimit > 0 || !isUnlockedForSpace) {
        return null;
    }
    const description = totalLimit < 0
        ? descriptionZeroBudget()
        : descriptionZeroBudgetNoExtraRollover();
    return (<View>
        {extraPadding ? <Spacer h={16}/> : null}
        <InfoCard backgroundColor={onCard ? colors.background.dark : ''} //
     noMargin>
          {description}
        </InfoCard>
        {extraPaddingBottom ? <Spacer h={16}/> : null}
      </View>);
};
const styles = StyleSheet.create({
    margin: {
        marginLeft: rem(8),
    },
});
export default BudgetingMonthlyCategoryToolTip;
